export const FILE_SIZE = 5 * 1024 * 1024;
export const PDF_DOC_FORMATS = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
];
